import {isNil} from 'ramda';

import {getIsMacPlatform, getSafely} from 'shared/web';

import {KeyboardShortcut} from '../constants/KeyboardShortcut';
import {KEYBOARD_SHORTCUT_DEFINITIONS} from '../constants/keyboardShortcutDefinitions';

export function getKeyboardShortcutLabel(shortcut: KeyboardShortcut): string | undefined {
  const definition = getSafely(KEYBOARD_SHORTCUT_DEFINITIONS, shortcut);
  if (isNil(definition)) {
    return undefined;
  }

  return getIsMacPlatform() ? definition.labelMac : definition.labelOther;
}
